module.exports = __webpack_public_path__ + "img/miset2a.a2d16880.jpg";